import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import emailotpReducer from "./auth/VerifyEmailOtp/reducer"
import otpReducer from "./auth/VerifyOtp/reducer"
import profileReducer from "./auth/ProfileProgress/reducer"
import employeeReducer from "./Employee/reducer"
import CrossSellReducer from "./Cross-sell/reducer"
import UpSellReducer from "./upSell/reducer"
import leadReducer from "./Leads/reducer"
import CustomerReducer from "./Customer/reducer"
import profilePhotoReducer from "./ProfilePhoto/reducer"
import PolicyReducer from "./Policy/reducer"
import PaymentReducer from "./PaymentGetway/reducer"
import fileUploadReducer from "./Bulk-Upload/reducer"
import AccessProfilereducer from "./auth/Access/reducer"
import ClaimFormReducer from "./ClaimForm/reducer"
import RenewalReducer from "./RenewalTracking/reducer"
import NotificationReducer from "./notifications/reducer"
import InsuranceNeedReducer from "./CalculateInsuranceNeed/reducer"
import TargetReducer from "./Target/reducer"
import ReferenceReducer from "./References/reducer"
import MutualFundReducer from "./MutualFund/reducer"
// Glogin Reducer



import SuperUserLogin from "./SuperAdmin/Authentication/Login/reducer"
import SuperUser from "./SuperAdmin/Authentication/Users/reducer"
import KnowledgeCenterReducer from "./SuperAdmin/KnowledgeCenter/reducer";
import VehicleMasterReducer from "./SuperAdmin/VehicleMaster/reducers"
import ManageRtoReducer from "./SuperAdmin/ManageRTO/Reducer"

import GloginReducer from "./auth/GoogleAuth/reducer"
import CustomFieldReducer from "./CustomFields/Reducer"
import DashboardReducer from "./Dashboard/reducer"
import SuperAdminLob from "./SuperAdmin/Lob-SubLob-company-income/reducer"
import ManageIncomeReducer from "./SuperAdmin/ManageIncomeRange/Reducer"
import ManageMarketingToolsReducer from "./SuperAdmin/MarketingTools/Reducers"
import MainKnowledgeCenterReducer from "./KnowledgeCenter/reducers"
import NdaAgreementReducer from "./NdaAgreement/Reducer"
import AdminNdaAgreementReducer from "./SuperAdmin/NdaAgreement/reducer"
import sendWhatsAppMsgReducer from "./SuperAdmin/SendWhatsAppMsg/reducer"
import ReportOtpReducer from "./ReportOtp/Reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  otpReducer,
  emailotpReducer,
  profileReducer,
  employeeReducer,
  leadReducer,
  CustomerReducer,
  GloginReducer,
  profilePhotoReducer,
  PolicyReducer,
  PaymentReducer,
  fileUploadReducer,
  CustomFieldReducer,
  DashboardReducer,
  AccessProfilereducer,
  CrossSellReducer,
  UpSellReducer,
  ClaimFormReducer,
  NotificationReducer,
  RenewalReducer,
  InsuranceNeedReducer,
  TargetReducer,
  MainKnowledgeCenterReducer,
  NdaAgreementReducer,
  ReportOtpReducer,
  ReferenceReducer,
  MutualFund: MutualFundReducer,
  //Super Users Reducers
  SuperUserLogin,
  SuperUser,
  KnowledgeCenterReducer,
  VehicleMasterReducer,
  SuperAdminLob,
  ManageRtoReducer,
  ManageIncomeReducer,
  ManageMarketingToolsReducer,
  AdminNdaAgreementReducer,
  sendWhatsAppMsgReducer
})

export default rootReducer;
